import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";
import { getData } from '../../../fetchRoutes/getData';
import { postData } from "../../../fetchRoutes/postData";

const backend = process.env.REACT_APP_BACKEND;
const socket = io(backend, { transports: ["websocket"] });

export default function SellerChat({ sellerId, onClose, onMinimize }) {
  const navigate = useNavigate();
  const getBuyer = process.env.REACT_APP_GET_BUYER_ID;
  const getChat = process.env.REACT_APP_CHAT;

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [chatId, setChatId] = useState(null);
  const chatEndRef = useRef(null);
  const [buyerId, setBuyerId] = useState(null);
  const [room, setRoom] = useState(null);

  const getBuyerUrl = `${getBuyer}/${sellerId}`;

  useEffect(() => {
    const getUserId = async () => {
      try {
        const response = await getData(getBuyerUrl);
        if (response.status === 'Success') setBuyerId(response.buyerId._id);
      } catch (error) {
        console.log(error);
      }
    };
    if (sellerId) getUserId();
  }, [getBuyerUrl, sellerId]);

  useEffect(() => {
    const fetchChat = async () => {
      const res = await postData(`${getChat}/${buyerId}/${sellerId}`);
      if (res.status === 'Success') {
        setChatId(res.chatId);
        setMessages(res.chat.messages || []);
      }
    };
    if (buyerId) fetchChat();
  }, [buyerId, getChat, sellerId]);

  useEffect(() => {
    if (!buyerId || !sellerId) return;
    socket.emit("joinRoom", { buyerId, sellerId }, (res) => {
      if (res.success) setRoom(res.room);
    });

    const handleMessage = (msg) => setMessages((prev) => [...prev, msg]);
    socket.on("receiveMessage", handleMessage);

    return () => socket.off("receiveMessage", handleMessage);
  }, [buyerId, sellerId]);

  useEffect(() => {
    if (chatEndRef.current) chatEndRef.current.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = () => {
    if (!message.trim() || !chatId || !room) return;

    const newMessage = { senderId: sellerId, text: message };

    socket.emit("sendMessage", {
      message: newMessage,
      room,
      senderId: sellerId,
      senderType: "Seller",
      chatId,
    });

    setMessage("");
  };

  const handleEndChat = () => {
    socket.emit("endChat", { sellerId });
    setMessages([]);
    setChatId(null);
    setRoom(null);
    navigate('/seller/chat');
  };

  return (
    <div className="chatContainer">
      <div className="chatTitle">
        <span className="chatSeller">Chat with Buyer</span>
        <div className="chatButtons">
          <button onClick={onMinimize} className="closeChat">–</button>
          <button onClick={() => { handleEndChat(); onClose(); }} className="closeChat">×</button>
        </div>
      </div>

      <div className="chatBox">
        {messages.map((msg, i) => (
          <div key={i} className={`messageBox ${msg.senderId === sellerId ? "sent" : "received"}`}>
            <span><strong>{msg.senderId === sellerId ? "You" : "Buyer"}:</strong> {msg.text}</span>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      <div className="chatMessageInput">
        <input
          className='fullName messageInput'
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          placeholder="Enter your message here"
        />
        <button onClick={sendMessage} className="sendMessage chat" />
      </div>
    </div>
  );
}
